var _circle, _path, _path2, _circle2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 21V24.5615C27 27.5647 23.8662 30 20 30C16.1338 30 13 27.5647 13 24.5615V21C13 24.0032 16.1338 26.1497 20 26.1497C23.8662 26.1497 27 24.0032 27 21Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27 16V20.8309C27 23.8454 23.8662 26 20 26C16.1338 26 13 23.8454 13 20.8309V16C13 16.8792 13.2692 17.6908 13.7431 18.3865C14.8954 20.087 17.2646 21.1691 20 21.1691C22.7354 21.1691 25.1046 20.087 26.2569 18.3865C26.7308 17.6908 27 16.8792 27 16Z",
    fill: "#292D32"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 23.5,
    r: 1,
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15.65C27 16.56 26.7308 17.4 26.2569 18.12C25.1046 19.88 22.7354 21 20 21C17.2646 21 14.8954 19.88 13.7431 18.12C13.2692 17.4 13 16.56 13 15.65C13 12.53 16.1338 10 20 10C21.9385 10 23.6831 10.63 24.9539 11.65C26.2139 12.68 27 14.09 27 15.65Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayout);
export default __webpack_public_path__ + "static/media/Payout.d5917ef3.svg";
export { ForwardRef as ReactComponent };